import { useEffect } from 'react';
import { useRouter } from 'next/router';

import { useAppDispatch } from 'store';

import { setRouteLoading } from 'modules/global/store/page-loading-slice';

const RouteLoader = () => {
  const { events } = useRouter();
  const dispatch = useAppDispatch();

  useEffect(() => {
    const handleStart = () => dispatch(setRouteLoading(true));
    const handleEnd = () => dispatch(setRouteLoading(false));

    events.on('routeChangeStart', handleStart);
    events.on('routeChangeComplete', handleEnd);
    events.on('routeChangeError', handleEnd);

    return () => {
      events.off('routeChangeStart', handleStart);
      events.off('routeChangeComplete', handleEnd);
      events.off('routeChangeError', handleEnd);
    };
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [events]);

  return null;
};

export default RouteLoader;
